module.exports = __webpack_public_path__ + "img/CEB299_6B5C4C_887564_746355-256px.7b178a0b.png";